import { Link } from "react-router-dom";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import PaginationView from "components/table/Pagination";
import store from "redux/store";
import { SHOW_REMOVE_MODAL } from "actions/types";
import { useTranslation } from "react-i18next";

export function Overview(props) {
  const { t, i18n } = useTranslation("productview");

  const showRemoveModal = (event, itemObj) => {
    event.preventDefault();
    const { removeUserEvent } = props;
    store.dispatch({
      type: SHOW_REMOVE_MODAL,
      message:
        "Weet u zeker dat u de geselecteerde gebruiker wilt ontkoppelen?<br/>Zijn of haar profiel blijft actief, alleen de koppeling met het bedrijf wordt verbroken.",
      header: "Ontkoppel gebruiker",
      data: itemObj,
      saveEvent: removeUserEvent,
    });
  };

  return (
    <>
      <div className="lg:flex lg:items-center lg:justify-between">
        <div className="flex-1 min-w-0">
          <h2 className="font-bold text-gray-900 text-2xl/7 sm:truncate sm:text-3xl sm:tracking-tight">
            Medewerkers beheren
          </h2>
          <div className="flex flex-col mt-1 sm:mt-0 sm:flex-row sm:flex-wrap sm:space-x-6">
            <p className="mt-2 max-w-2xl text-sm text-gray-500">
              Hier vind u een overzicht van alle medewerkers die aan dit bedrijf
              gekoppeld zijn. U kunt hier de gegevens van een medewerker
              aanpassen of een nieuwe medewerker toevoegen.
            </p>
          </div>
        </div>
        <div className="flex mt-5 lg:ml-4 lg:mt-0">
          <span className="sm:ml-3">
            <Link
              to={`/company/${props.companyid}/user/add`}
              className="btn-primary"
            >
              Medewerker toevoegen
            </Link>
          </span>
        </div>
      </div>

      <div className="flow-root mt-8">
        <div className="overflow-x-auto -mx-4 -my-2 sm:-mx-6 lg:-mx-8">
          <div className="inline-block py-2 min-w-full align-middle sm:px-6 lg:px-8">
            <table className="min-w-full divide-y divide-gray-300">
              <thead>
                <tr>
                  <th
                    scope="col"
                    className="py-3.5 pr-3 pl-4 text-sm font-semibold text-left text-gray-900 sm:pl-0"
                  >
                    Naam
                  </th>
                  <th
                    scope="col"
                    className="px-3 py-3.5 text-sm font-semibold text-left text-gray-900"
                  >
                    Type
                  </th>
                  <th scope="col" className="relative py-3.5 pr-4 pl-3 sm:pr-0">
                    <span className="sr-only">Acties</span>
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {props.items.map((item) => (
                  <tr key={item.id}>
                    <td className="py-4 pr-3 pl-4 text-sm font-medium text-gray-900 whitespace-nowrap sm:pl-0">
                      <div className="flex items-center">
                        <div>
                          <p className="font-medium">{item.full_name}</p>
                        </div>
                      </div>
                    </td>
                    <td className="px-3 py-4 text-sm text-gray-500 whitespace-nowrap">
                      <span className="inline-flex px-2 text-xs font-semibold leading-5 text-blue-700 bg-blue-50 rounded-full">
                        {item.user_type}
                      </span>
                    </td>
                    <td className="relative py-4 pr-4 pl-3 text-sm font-medium text-right whitespace-nowrap sm:pr-0">
                      <Menu
                        as="div"
                        className="inline-block relative text-left"
                      >
                        <div>
                          <MenuButton className="flex gap-2 items-center btn-secondary">
                            Meer
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="-mr-1 text-gray-400 size-4"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M20 9L12 17L4 9"
                                stroke="currentColor"
                                strokeWidth="2"
                              />
                            </svg>
                          </MenuButton>
                        </div>
                        <MenuItems
                          transition
                          className="absolute right-0 z-10 mt-2 w-56 origin-top-right bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                        >
                          <div className="py-1">
                            <MenuItem>
                              <Link
                                to={`/company/${props.companyid}/user/edit/${item.id}`}
                                className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="text-gray-500"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                </svg>
                                Medewerker bewerken
                              </Link>
                            </MenuItem>

                            {item.user_type !== "OWNER" && (
                              <MenuItem>
                                <button
                                  onClick={(event) =>
                                    showRemoveModal(event, item)
                                  }
                                  className="flex items-center gap-2 w-full text-left px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="text-gray-500"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                                  </svg>
                                  Medewerker verwijderen
                                </button>
                              </MenuItem>
                            )}
                          </div>
                        </MenuItems>
                      </Menu>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <PaginationView
        pagingEventHandler={props.pagingEventHandler}
        pagination={props.pagination}
      />
    </>
  );
}
